import queryString from 'query-string'
import { useNavigate, useLocation } from 'react-router-dom'

export const useQuery = <T>() => {
  const location = useLocation<T>()
  const navigate = useNavigate()
  const query: T = queryString.parse(location.search) as any
  return {
    search: query,
    set: (search: T, push?: boolean) => {
      console.log('[useQuery] -> Setting search:', search)
      const path = `${location.pathname}?${
        queryString.stringify(search as any) ?? ''
      }`
      navigate(path, { replace: !push })
    },
  }
}
